import React from 'react';

import { Container } from '../common/container';
import Text from '../common/text';
import { FooterBottom, FooterWrapper } from './styles';
import FooterTop from './FooterTop';

type FooterProps = {
  forIframe?: boolean;
};

function Footer({ forIframe }: FooterProps) {
  return (
    <FooterWrapper>
      <FooterTop forIframe={forIframe} />
      <FooterBottom>
        <Container size="md">
          <div className="top">
            <Text>
              The information provided regarding the business opportunity of
              Richr Homes reducing its broker fee from 3% to 1% if the Seller
              invests at least 2% of its sales proceeds into an investment
              account at Richr Money LLC is for informational purposes only and
              should not be considered legal, tax or financial advice. The
              decision to invest in any investment account should be made after
              consulting with your financial advisor, tax advisor and attorney.
              Richr Money LLC and Richr Homes are affiliated businesses and
              therefore have a vested interest in the success of both businesses
              and the reduction associated with this opportunity. We encourage
              potential investors to ask questions and seek counsel before
              making any investment decisions. All investments are risky and
              subject to loss. Additionally, the answers provided to the risk
              assessment questions may directly affect the products suggested by
              Richr Money LLC for investment. We encourage potential investors
              to take their time when answering these questions to ensure the
              best fit for their individual financial goals and risk tolerance.
              Additional information about Richr Money can be found in its Form
              ADV Parts 2A, 2B and 3 (CRS), available upon request.
            </Text>
          </div>
          <div className="bottom">
            <Text>
              All information provided is deemed reliable but is not guaranteed
              and should be independently verified. You should consult your own
              professionals for financial, legal, or tax advice and conduct your
              own due diligence. Brokerage services are provided by Richr MP
              Holdings LLC DBA Richr Homes, FL License # 1060165. Services of
              Richr affiliates, Richr Homes, Richr Money LLC, Richr Insurance
              LLC and Richr Title LLC, are optional.
            </Text>
          </div>
        </Container>
      </FooterBottom>
    </FooterWrapper>
  );
}

export default Footer;
